var React = require('react');

function WebsitePolyclusterInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M29.9683 73.4133L21.2034 96.0865L5.95033 77.1593L29.9683 73.4133Z","stroke":"#FF5A7D","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M152.714 95.4175L111.94 126.765L105.18 75.7792L152.714 95.4175Z","stroke":"#B1F8FC","strokeWidth":"2","key":1}),React.createElement("path",{"d":"M29.2996 7.96042L47.6253 12.1258L34.8552 25.9136L29.2996 7.96042Z","fill":"#C99CEF","key":2})]);
}

WebsitePolyclusterInline.defaultProps = {"width":"165","height":"141","viewBox":"0 0 165 141","fill":"none"};

module.exports = WebsitePolyclusterInline;

WebsitePolyclusterInline.default = WebsitePolyclusterInline;
